// TopBar.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../theme/tokens';
import PersonChip from './PersonChip';

const TOPBAR_HEIGHT = 70;
const APP_NAME = 'Louw';

const TopBar = () => {
  return (
    <Box
      component="header"
      sx={{
        height: TOPBAR_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 3.75,
        position: 'sticky',
        top: 0,
        backgroundColor: 'transparent',
        zIndex: 20,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: 18,
            backgroundImage: tokens.gradient.avatar,
            color: '#0a0b10',
          }}
        >
          {APP_NAME.charAt(0)}
        </Box>
        <Typography sx={{ fontSize: 15, fontWeight: 700, color: tokens.colors.txt }}>
          {APP_NAME}
        </Typography>
      </Box>

      <Box sx={{ flex: 1 }} />

      <PersonChip />
    </Box>
  );
};

export default TopBar;
export { TOPBAR_HEIGHT };